import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type RemoveSearchAlertCall = (
  userId: number,
  searchAlertId: number,
) => Promise<{ data: null }>;

export default (makeCall: MakeCall) => (
  userId: number,
  searchAlertId: number,
) =>
  makeCall<null>(
    'DELETE',
    `${APIV2_URL}/user/${userId}/search-alert/${searchAlertId}`,
  );
